const buyCoinForm = (amount) => {
  const location = window.location.href;
  const baseUrl = location.split("/buy-coins")[0];

  return (
    <form
      action="https://www.coinpayments.net/index.php"
      method="post"
      target="_blank"
    >
      <input type="hidden" name="cmd" value="_pay" />
      <input type="hidden" name="reset" value="1" />
      <input
        type="hidden"
        name="merchant"
        value="593e110319be052a19a71f05d8e7a0f6"
      />
      <input type="hidden" name="item_name" value={`$${amount} Pack`} />
      <input type="hidden" name="currency" value="USD" />
      <input type="hidden" name="amountf" value={amount} />
      <input type="hidden" name="quantity" value="1" />
      <input type="hidden" name="allow_quantity" value="0" />
      <input type="hidden" name="want_shipping" value="0" />
      <input
        type="hidden"
        name="success_url"
        value={`${baseUrl}/payment-success`}
      />
      <input
        type="hidden"
        name="cancel_url"
        value={`${baseUrl}/payment-decline`}
      />
      <input
        type="hidden"
        name="ipn_url"
        value="https://wgcapi.mmocircles.com/webhook/coinpayments-ipn"
      />
      <input type="hidden" name="allow_extra" value="0" />
      <label
        htmlFor={`submit${amount}`}
        className="btn btn-warning-bg btn-primary-cs w-250 my-auto"
      >
        <span>Buy Now</span>
        <small className="d-block package-buy-small">
          Pay Using Coin Payment
        </small>
      </label>
      <input
        id={`submit${amount}`}
        type="image"
        src="https://www.coinpayments.net/images/pub/buynow-grey.png"
        alt="Buy Now with CoinPayments.net"
        style={{ display: "none" }}
      />
    </form>
  );
};

export default buyCoinForm;
